<div class="pdbc-section-container">
    <div class="pdbc-dateguests-title top">
        <span class="hb-dateguests-title-nr one">1</span>
        <span>{{ "Dates & Guests" | translate }}</span>
        <ion-icon name="calendar-outline"></ion-icon>
    </div>
    <div class="pdbc-date-and-occup">
        <md-search-occupancy
            #occupancy
            (occupancyChanged)="onOccupancyChanged($event)"
            (mobileOccupancyClosed)="onMobileOccupancySearchClick()"
            [initialOccupancy]="selectedOccupancy"
            [occupancyLimits]="occupancyLimits"
            [darkBackgroundOnOpen]="false"
            [showChildAgeLabel]="false"
        >
            <div
                targetControl
                class="pdbc-picker occup"
                (click)="onOccupancyClicked()"
            >
                <ion-icon name="person-outline"></ion-icon>
                <span class="sd-occup-value">{{ occupancyString }}</span>
            </div>
        </md-search-occupancy>
        <md-calendar
            #calendarHotel
            [infoForEachDay]="additionalCalendarDayInfo"
            (dateRangeSelected)="onDateRangeSelected($event)"
            [showDesktopInPopup]="true"
            [darkBackgroundOnOpen]="false"
            [dontCallOpenCalendarOnClick]="true"
            ><div
                popupTargetControl
                class="pdbc-picker"
                (click)="onDatesClick()"
            >
                <div class="pdbc-picker-date">
                    <ion-icon name="calendar-clear-outline"></ion-icon>
                    <span>{{ fromDate | ngbDateFormat }}</span>
                </div>

                <div class="pdbc-picker-date">
                    <ion-icon name="calendar-clear-outline"></ion-icon>
                    <span>{{ toDate | ngbDateFormat }}</span>
                </div>
            </div>
        </md-calendar>
    </div>
</div>
<ng-container *ngIf="!isInvenotoryLoading">
    <div class="pdbc-section-container">
        <div class="pdbc-dateguests-title">
            <span class="hb-dateguests-title-nr">2</span>
            {{
                (roomsWithCheapestMealPlans?.length > 1
                    ? "Change rooms"
                    : "Room option"
                ) | translate
            }}
        </div>
        <div class="pdbc-dateguests-subtitle">
            {{ "For" | translate }} {{ occupancyString }}({{
                fromDate | ngbDateFormat : true
            }}-{{ toDate | ngbDateFormat : true }})
        </div>
        <label
            *ngFor="let room of roomsWithCheapestMealPlans"
            class="pdbc-room-label"
            [ngClass]="{ 'pdbc-disabled': room.isCurrentlyDisabled }"
        >
            <div>
                <input
                    type="radio"
                    name="room"
                    [checked]="selectedRoomId === room.roomId"
                    (click)="onRoomChanged(room)"
                />
                <div>
                    <span>{{ room.roomName }}</span>
                    <span style="font-size: 8px">{{
                        room.reasonForDisabled
                    }}</span>
                </div>
            </div>
            <span class="hb-option-price">
                {{
                    room.cheapestMealPlan.sellingPrice
                        | currency
                            : currencySymbol
                            : "symbol"
                            : "1.0-2"
                            : locale
                }}</span
            >
        </label>
        <div class="hb-per-night">{{ "* per night" | translate }}</div>
    </div>
    <div class="pdbc-section-container">
        <div class="pdbc-dateguests-title">
            <span class="hb-dateguests-title-nr">3</span>
            {{
                (selectedRoomMealPlans?.length > 1
                    ? "Upgrade meal plan"
                    : "Meal plan"
                ) | translate
            }}
        </div>
        <div class="pdbc-dateguests-subtitle">
            {{ "For" | translate }} {{ occupancyString }}({{
                fromDate | ngbDateFormat : true
            }}-{{ toDate | ngbDateFormat : true }})
        </div>
        <label
            *ngFor="let mealPlan of selectedRoomMealPlans"
            class="pdbc-room-label"
        >
            <div>
                <input
                    type="radio"
                    name="mealPlan"
                    [checked]="selectedMealPlanId === mealPlan.mealPlanId"
                    (click)="onMealPlanChanged(mealPlan)"
                />
                <span>{{ mealPlan.mealPlanType }}</span>
            </div>
            <span
                class="hb-option-price"
                [ngClass]="{ green: mealPlan.priceDifferenceWithCheapest > 0 }"
                >+
                {{
                    mealPlan.priceDifferenceWithCheapest
                        | currency
                            : currencySymbol
                            : "symbol"
                            : "1.0-2"
                            : locale
                }}</span
            >
        </label>
        <div class="hb-per-night">{{ "* per night" | translate }}</div>
    </div>
    <div class="pdbc-section-container hb-selection-summary">
        <div class="hb-selection-summary-column">
            <div class="hb-dates-summary-top">{{ "Check-in" | translate }}</div>
            <div class="hb-dates-summary-bottom">
                {{ fromDate | ngbDateFormat }}
            </div>
        </div>
        <div class="hb-selection-summary-mid">
            <div class="hb-dates-summary-top">
                {{ "Check-out" | translate }}
            </div>
            <div class="hb-dates-summary-bottom">
                {{ toDate | ngbDateFormat }}
            </div>
        </div>
        <div class="hb-selection-summary-column">
            <div class="hb-dates-summary-top">{{ "Night(s)" | translate }}</div>
            <div class="hb-dates-summary-bottom" style="text-align: center">
                {{ totalNights }}
            </div>
        </div>
    </div>
</ng-container>

<md-hotel-booking-loading *ngIf="isInvenotoryLoading" />
